export enum QueryParams {
  CATEGORIES_KEY = "category-response",
  STORE_CONFIG_KEY = "store-config",
  CUSTOM_DOMAIN_KEY = "custom-domain",
  GET_ALL_PRODUCTS_KEY = "get-all-products",
  GET_ALL_CATEGORIES_KEY = "get-all-categories",
  UPLOAD_IMAGE_KEY = "upload-image",
}
